import React, { useState, useEffect, useRef } from 'react';
import { FaSignOutAlt, FaList } from 'react-icons/fa';
import wixLogo from '../assets/wix.png';
import agFacturaLogo from '../assets/ag.png';
import bidireccional from '../assets/bidireccional.png';
import Login from './Login';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL; // Backend HTTP API base URL
const WS_URL = process.env.REACT_APP_WS_URL;   // Ejemplo: ws://localhost:4000

export default function MonitoringScreen() {
  let reconnectTimeout;
  const isManualCloseRef = useRef(false);
  const logContainerRef = useRef(null);
  const [monitorStatus, setMonitorStatus] = useState(null);
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(() => localStorage.getItem('loggedIn') === 'true');

  // Guardamos referencia al WebSocket para cerrar cuando se desmonta
  const wsRef = useRef(null);
  const hasConnected = useRef(false);

  useEffect(() => {
    if (logContainerRef.current) {
      logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
    }
  }, [monitorStatus?.log?.length]);

  useEffect(() => {
    if (!isLoggedIn || hasConnected.current) return;
      hasConnected.current = true;

    

    const connect = () => {
      isManualCloseRef.current = false;
      const apiKey = encodeURIComponent(process.env.REACT_APP_API_KEY);
      const ws = new WebSocket(WS_URL+'?apiKey=' + apiKey);
      wsRef.current = ws;

      console.log("Intentando conectar al WebSocket...");

      ws.onopen = () => {
        console.log("✅ Conexión WebSocket abierta");
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          setMonitorStatus(data);
          if (logContainerRef.current) {
            logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
          }
        } catch (err) {
          console.error("Error parseando mensaje WS:", err);
        }
      };

      ws.onerror = (error) => {
        console.error("❌ Error WebSocket:", error);
      };

      ws.onclose = () => {
        hasConnected.current = false;
        if (!isManualCloseRef.current) {
          console.warn("⚠️ WebSocket cerrado. Reintentando en 2 segundos...");
          reconnectTimeout = setTimeout(() => connect(), 2000);
        }
      };
    };

    connect();

    return () => {
      hasConnected.current = false;
      isManualCloseRef.current = true;
      clearTimeout(reconnectTimeout);
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.close();
      }
    };
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return <Login onLogin={() => setIsLoggedIn(true)} />;
  }

  const handleLogout = () => {
    hasConnected.current = false;
    isManualCloseRef.current = true;
    clearTimeout(reconnectTimeout);
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.close();
    }
    localStorage.removeItem('loggedIn');
    setIsLoggedIn(false);
  };

  const goBackToClients = () => {
    navigate('/client-list');
  };

  // NUEVA FUNCIÓN para iniciar o detener el proceso
  const toggleActivation = async () => {
    if (monitorStatus?.active === undefined) return;

    const newValue = !monitorStatus.active;

    try {
      const response = await fetch(`${API_URL}/sync/set-active?value=${newValue}`, {
        headers: { 'x-api-key': process.env.REACT_APP_API_KEY },
        method: 'POST',
      });

      if (!response.ok) {
        console.error("Error actualizando el estado activo del proceso");
      }
    } catch (error) {
      console.error("Error de red al cambiar estado activo:", error);
    }
  };



  return (
    <div className="max-w-5xl mx-auto p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">AG Factura Wix Stores Connector</h1>
        <div className="flex gap-2">
          <button
            onClick={goBackToClients}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2"
          >
            <FaList />
            Lista de Clientes
          </button>
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 flex items-center gap-2"
          >
            <FaSignOutAlt />
            Cerrar sesión
          </button>
        </div>
      </div>

      <div className="flex gap-4 items-center mb-6">
        <img src={wixLogo} alt="Wix Logo" className="h-12 rounded" />
        <img src={bidireccional} alt="Interfaz" className="h-12" />
        <img src={agFacturaLogo} alt="AG Factura Logo" className="h-12" />
      </div>

      <div className="border-4 border-dashed border-gray-300 rounded-lg p-4 text-gray-800 bg-white shadow-md w-full">
        {monitorStatus ? (
          <div>
            <p><b>Estado:</b> {monitorStatus.running ? 'En ejecución' : 'Detenido'}</p>
            <p><b>Último inicio:</b> {monitorStatus.lastStart || 'N/A'}</p>
            <p><b>Último fin:</b> {monitorStatus.lastEnd || 'N/A'}</p>
            <p><b>Próxima ejecución:</b> {monitorStatus.nextRun || 'N/A'}</p>
            <div className="mt-4">
              <button
                onClick={toggleActivation}
                className={`px-4 py-2 rounded text-white font-semibold ${
                  monitorStatus?.active ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-green-600 hover:bg-green-700'
                }`}
              >
                {monitorStatus?.active ? 'Desactivar Proceso de Sincronización Automática' : 'Activar Proceso de Sincronización Automática'}
              </button>
            </div>
            <div className="mt-4">
              <h2 className="font-semibold mb-2">Logs:</h2>
              <ul ref={logContainerRef} className="list-disc list-inside max-h-60 overflow-auto">
                {monitorStatus.log.length > 0 ? (
                  monitorStatus.log.map((entry, index) => (
                    <li key={index}>{entry}</li>
                  ))
                ) : (
                  <li>Sin registros aún.</li>
                )}
              </ul>
            </div>
          </div>
        ) : (
          <p>Cargando estado del monitor...</p>
        )}
      </div>
    </div>
  );
}
